<template>
  <div v-if="loading" class="loading-overlay">
    <div class="d-flex align-items-center gap-3 flex-column">
      <div>
        <v-progress-circular
          :size="60"
          :width="6"
          color="#6277E4"
          indeterminate
        >
        </v-progress-circular>
      </div>
    </div>
  </div>
  <Transition name="fade" mode="out-in">
    <slot></slot>
  </Transition>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const loading = ref(false); // Controls the visibility of the loading overlay
const router = useRouter();

// Show loading overlay during page transitions
router.beforeEach(() => {
  loading.value = true; // Start loading when navigating to a new page
});

router.afterEach(() => {
  loading.value = false; // Hide loading overlay once the transition is complete
  // Introduce a longer delay before hiding the loading overlay
});

</script>

<style scoped>
.transition-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.transition-icon {
  position: absolute;
  top: -20px;
  opacity: 0.7;
  animation: bounce 1s infinite alternate;
}

.icon {
  width: 40px;
  height: 40px;
  color: #586CDA; /* Adjust color as needed */
}

/* Transition effects */
.fade-slide-enter-active, .fade-slide-leave-active {
  transition: opacity 0.75s ease-in-out, transform 0.75s ease-in-out;
}

.fade-slide-enter {
  opacity: 0;
  transform: translateY(20px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

/* Icon bounce animation */
@keyframes bounce {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-10px);
  }
}
</style>
